// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-input {
  width: 130px;
  margin-bottom: 10px;
  display: inline-block;
}

.custom-select {
  width: 180px;
  margin-bottom: 10px;
  display: inline-block;
  vertical-align: middle; /* Aligns with the middle of the text */
}

.no-hidden-overflow {
  overflow: visible !important;
}

.statement-container,
.statement-multiline {
  line-height: 1.5; /* Adjust as needed to match your text */
}
.statement-container img,
.statement-multiline img {
  max-width: 100% !important;
  width: auto !important;
  height: auto !important;
  display: block;
  margin: 0 auto;
}
.statement-container span img,
.statement-multiline span img {
  max-width: 100% !important;
  width: auto !important;
  height: auto !important;
  display: block;
  margin: 0 auto;
}

.custom-select .react-select__single-value {
  font-size: 16px; /* Match your text font size */
}`, "",{"version":3,"sources":["webpack://./src/components/Practice/Preview.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,mBAAA;EACA,qBAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA,EAAA,uCAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;;EAEE,gBAAA,EAAA,wCAAA;AACF;AAEE;;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AACJ;AAII;;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AADN;;AAMA;EACE,eAAA,EAAA,8BAAA;AAHF","sourcesContent":[".custom-input {\n  width: 130px;\n  margin-bottom: 10px;\n  display: inline-block;\n}\n\n.custom-select {\n  width: 180px;\n  margin-bottom: 10px;\n  display: inline-block;\n  vertical-align: middle; /* Aligns with the middle of the text */\n}\n\n.no-hidden-overflow {\n  overflow: visible !important;\n}\n\n.statement-container,\n.statement-multiline {\n  line-height: 1.5; /* Adjust as needed to match your text */\n\n  // Fix for images with inline width/height attributes\n  img {\n    max-width: 100% !important;\n    width: auto !important;\n    height: auto !important;\n    display: block;\n    margin: 0 auto;\n  }\n\n  // Ensure nested content (like spans with dangerouslySetInnerHTML) also follows the rules\n  span {\n    img {\n      max-width: 100% !important;\n      width: auto !important;\n      height: auto !important;\n      display: block;\n      margin: 0 auto;\n    }\n  }\n}\n\n.custom-select .react-select__single-value {\n  font-size: 16px; /* Match your text font size */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
